@if (isVisible()) {
  @if (mode() === 'legacy') {
    <div class="flex items-center justify-between gap-4 bg-orangeWashed border-b border-orange px-6 py-3">
      <div class="flex items-center gap-3 text-orange text-sm">
        <i class="fas fa-history text-base"></i>
        <span i18n>Uporabljate staro različico strani. Preizkusite novo obliko.</span>
      </div>
      <button type="button" class="btn btn-primary btn-sm" (click)="toggle()" i18n>
        Preklopi na novo obliko
      </button>
    </div>
  } @else {
    <div class="flex items-center justify-between gap-4 bg-greenWashed border-b border-green px-6 py-3">
      <div class="flex items-center gap-3 text-green text-sm">
        <i class="fas fa-sparkles text-base"></i>
        <span i18n>Uporabljate novo obliko strani. Potrebujete staro različico? Opozarjamo, da bo stara različica v kratkem trajno ukinjena.</span>
      </div>
      <button type="button" class="btn btn-grayDark-outline btn-sm" (click)="toggle()" i18n>
        Preklopi na staro obliko
      </button>
    </div>
  }
}
